import { Component, OnInit } from '@angular/core';
import { VisitorsService } from 'src/app/shared/service/visitors.service';

@Component({
  selector: 'app-parts-report',
  templateUrl: './parts-report.component.html',
  styleUrls: ['./parts-report.component.scss']
})
export class PartsReportComponent  {
  public partsList: { ID: number, AR_Name: string, Views: number }[] = []

  constructor(
    visitorService: VisitorsService,
  ) {
    visitorService.getPartsReport().subscribe(response => {
      this.partsList = response;
    });
  }


  public settings = {
    pager: {
      perPage: 50,
    },

    actions: {
      add: false,
      edit: false,
      delete: false,
      position: 'right'
    },
    columns: {
      // ID: {
      //   title: 'ID',
      //   width: '50px',
      //   filter: false,
      // },
      AR_Name: {
        title: 'اسم الفرع'
      },
      Views: {
        title: 'اجمالي المشاهدات',
        width: '250px',
      },
    },
  };
}